export default "__VITE_ASSET__BFp9xT1E__"